/**
 *@file ajax
 *@version 1.0.1
 *@author wuwg
 *@createTime 2019/8/27 - 10:53
 *@updateTime 2019/8/27 - 10:53
 *@see [jsDoc中文文档]{@link  http://www.dba.cn/book/jsdoc/JSDOCKuaiBiaoQianBLOCKTAGS/CONSTRUCTS.html}
 *      [axios github]{@link https://github.com/axios/axios}
 *      [axios 简书]{@link https://www.jianshu.com/p/7a9fbcbb1114}
 *      [axios 简书]{@link https://www.jianshu.com/p/df464b26ae58}
 *      [axios 中文文档]{@link https://www.kancloud.cn/yunye/axios/234845 }
 @description ajax 的描述
 */
import ajax from 'axios';
import axios from 'axios';
import Vue from 'vue';
import router from '@/router/index.js';
import { Message } from 'element-ui';
// 开始
ajax.globalBefore = function() {
    // ajax 开始加载
    Vue.prototype.$AjaxLoading.start();
    // 开始加载
    window.postMessage(JSON.stringify({ cmd: 'loading-start' }), '*');
};
// 结束
ajax.globalAfter = function() {
    // ajax 加载结束
    Vue.prototype.$AjaxLoading.finish();
    // 开始加载
    window.postMessage(JSON.stringify({ cmd: 'loading-finish' }), '*');
};
// 前置拦截器
ajax.interceptors.request.use(function(config) {
    const _config = config || {};
    _config.headers = _config.headers || {};
    //  _config.headers['X-Requested-With'] = 'XMLHttpRequest';
    // 如果启用全局事件
    if (localStorage.tokenToC) { //判断token是否存在
        _config.headers.token = localStorage.tokenToC; //将token设置成请求头
    }
    _config.headers.type = 'programmer'
    if (!_config.forbidGlobal) {
        // 执行全局函数
        ajax.globalBefore();
    }
    // debugger
    // 前置函数
    if (typeof _config.before === 'function') {
        _config.before();
    }
    return config;
}, function(error) {
    // 对请求错误做些什么
    return Promise.reject(error);
});

// 后置拦截器
ajax.interceptors.response.use(function(response) {

    // axios.post(window.fdConfig.url.common('getMessageCount')).then((res) => {
    //     console.log(res, 'res')
    // })

    //console.log(response, 'response**********')
    if (response.data.code === 3) {
        // localStorage.removeItem('tokenToC');
        // localStorage.removeItem('userDataToC');
        let openPathProg
        if (location.href.indexOf('://www.itjob365.com') != -1 || location.href.indexOf('://itjob365.com') != -1 || location.href.indexOf('hr.itjob365.com') != -1) { //生产

            openPathProg = 'https://www.itjob365.com/#/home'

        } else if (location.href.indexOf('hrtest.itjob365.com/show') != -1) {
            openPathProg = 'https://hrtest.itjob365.com/websitePC/#/home'

        } else {
            openPathProg = 'https://hrtest.itjob365.com/websitePC/#/home'

        }
        if (location.href.indexOf('shareId') != -1) {

            openPathProg = openPathProg + '?' + location.href.split('?')
        }
        var a = document.createElement('a')
        a.setAttribute('href', openPathProg)

        a.style.visibility = 'hidden'

        a.click();

        //alert('登录已过期，请重新登录');
        /* alert('请重新登录') */

    }
    if (!response.config.forbidGlobal) {
        // 执行全局函数
        ajax.globalAfter();
    }
    // 后置函数
    if (typeof response.config.after === 'function') {
        response.config.after();
    }
    // 对响应数据做点什么
    return response;
}, function(error) {
    // 执行全局函数
    ajax.globalAfter();
    // 对响应错误做点什么
    return Promise.reject(error);
});

export default ajax;

// https://github.com/axios/axios
// https://www.jianshu.com/p/7a9fbcbb1114
// https://www.jianshu.com/p/df464b26ae58 (中文文档)
// https://www.kancloud.cn/yunye/axios/234845   (中文文档)
/*
 * request
 * config  options
 {
 // `url` is the server URL that will be used for the request
 url: '/user',

 // `method` is the request method to be used when making the request
 method: 'get', // default

 // `baseURL` will be prepended to `url` unless `url` is absolute.
 // It can be convenient to set `baseURL` for an instance of axios to pass relative URLs
 // to methods of that instance.
 baseURL: 'https://some-domain.com/api/',

 // `transformRequest` allows changes to the request data before it is sent to the server
 // This is only applicable for request methods 'PUT', 'POST', and 'PATCH'
 // The last function in the array must return a string or an instance of Buffer, ArrayBuffer,
 // FormData or Stream
 // You may modify the headers object.
 transformRequest: [function (data, headers) {
 // Do whatever you want to transform the data
 return data;
 }],

 // `transformResponse` allows changes to the response data to be made before
 // it is passed to then/catch
 transformResponse: [function (data) {
 // Do whatever you want to transform the data
 return data;
 }],

 // `headers` are custom headers to be sent
 headers: {'X-Requested-With': 'XMLHttpRequest'},

 // `params` are the URL parameters to be sent with the request
 // Must be a plain object or a URLSearchParams object
 params: {
 ID: 12345
 },

 // `paramsSerializer` is an optional function in charge of serializing `params`
 // (e.g. https://www.npmjs.com/package/qs, http://api.jquery.com/jquery.param/)
 paramsSerializer: function(params) {
 return Qs.stringify(params, {arrayFormat: 'brackets'})
 },

 // `data` is the data to be sent as the request body
 // Only applicable for request methods 'PUT', 'POST', and 'PATCH'
 // When no `transformRequest` is set, must be of one of the following types:
 // - string, plain object, ArrayBuffer, ArrayBufferView, URLSearchParams
 // - Browser only: FormData, File, Blob
 // - Node only: Stream, Buffer
 data: {
 firstName: 'Fred'
 },

 // `timeout` specifies the number of milliseconds before the request times out.
 // If the request takes longer than `timeout`, the request will be aborted.
 timeout: 1000,

 // `withCredentials` indicates whether or not cross-site Access-Control requests
 // should be made using credentials
 withCredentials: false, // default

 // `adapter` allows custom handling of requests which makes testing easier.
 // Return a promise and supply a valid response (see lib/adapters/README.md).
 adapter: function (config) {
 /!* ... *!/
 },

 // `auth` indicates that HTTP Basic auth should be used, and supplies credentials.
 // This will set an `Authorization` header, overwriting any existing
 // `Authorization` custom headers you have set using `headers`.
 auth: {
 username: 'janedoe',
 password: 's00pers3cret'
 },

 // `responseType` indicates the type of data that the server will respond with
 // options are 'arraybuffer', 'blob', 'document', 'json', 'text', 'stream'
 responseType: 'json', // default

 // `responseEncoding` indicates encoding to use for decoding responses
 // Note: Ignored for `responseType` of 'stream' or client-side requests
 responseEncoding: 'utf8', // default

 // `xsrfCookieName` is the name of the cookie to use as a value for xsrf token
 xsrfCookieName: 'XSRF-TOKEN', // default

 // `xsrfHeaderName` is the name of the http header that carries the xsrf token value
 xsrfHeaderName: 'X-XSRF-TOKEN', // default

 // `onUploadProgress` allows handling of progress events for uploads
 onUploadProgress: function (progressEvent) {
 // Do whatever you want with the native progress event
 },

 // `onDownloadProgress` allows handling of progress events for downloads
 onDownloadProgress: function (progressEvent) {
 // Do whatever you want with the native progress event
 },

 // `maxContentLength` defines the max size of the http response content in bytes allowed
 maxContentLength: 2000,

 // `validateStatus` defines whether to resolve or reject the promise for a given
 // HTTP response status code. If `validateStatus` returns `true` (or is set to `null`
 // or `undefined`), the promise will be resolved; otherwise, the promise will be
 // rejected.
 validateStatus: function (status) {
 return status >= 200 && status < 300; // default
 },

 // `maxRedirects` defines the maximum number of redirects to follow in node.js.
 // If set to 0, no redirects will be followed.
 maxRedirects: 5, // default

 // `socketPath` defines a UNIX Socket to be used in node.js.
 // e.g. '/var/run/docker.sock' to send requests to the docker daemon.
 // Only either `socketPath` or `proxy` can be specified.
 // If both are specified, `socketPath` is used.
 socketPath: null, // default

 // `httpAgent` and `httpsAgent` define a custom agent to be used when performing http
 // and https requests, respectively, in node.js. This allows options to be added like
 // `keepAlive` that are not enabled by default.
 httpAgent: new http.Agent({ keepAlive: true }),
 httpsAgent: new https.Agent({ keepAlive: true }),

 // 'proxy' defines the hostname and port of the proxy server
 // Use `false` to disable proxies, ignoring environment variables.
 // `auth` indicates that HTTP Basic auth should be used to connect to the proxy, and
 // supplies credentials.
 // This will set an `Proxy-Authorization` header, overwriting any existing
 // `Proxy-Authorization` custom headers you have set using `headers`.
 proxy: {
 host: '127.0.0.1',
 port: 9000,
 auth: {
 username: 'mikeymike',
 password: 'rapunz3l'
 }
 },

 // `cancelToken` specifies a cancel token that can be used to cancel the request
 // (see Cancellation section below for details)
 cancelToken: new CancelToken(function (cancel) {
 })
 }*/

/**
 *
 axios.request(config)

 axios.get(url[, config])

 axios.delete(url[, config])

 axios.head(url[, config])

 axios.options(url[, config])

 axios.post(url[, data[, config]])

 axios.put(url[, data[, config]])

 axios.patch(url[, data[, config]])

 axios.all(iterable)

 axios.spread(callback)
 */
/**
 * Response
 * {
  // `data` is the response that was provided by the server
  data: {},

  // `status` is the HTTP status code from the server response
  status: 200,

  // `statusText` is the HTTP status message from the server response
  statusText: 'OK',

  // `headers` the headers that the server responded with
  // All header names are lower cased
  headers: {},

  // `config` is the config that was provided to `axios` for the request
  config: {},

  // `request` is the request that generated this response
  // It is the last ClientRequest instance in node.js (in redirects)
  // and an XMLHttpRequest instance the browser
  request: {}
}
 // 实例
 axios.get('/user/12345')
 .then(function(response) {
    console.log(response.data);
    console.log(response.status);
    console.log(response.statusText);
    console.log(response.headers);
    console.log(response.config);
  });
 */


// WEBPACK FOOTER //
// ./src/components/tools/extend/ajax.js